import React from 'react';

const ImageItem = (props) => {
	const imageCss = {
		backgroundColor: '#e0e0e0',
		backgroundImage: `url(${props.url})`,
	}
	return (
		<div onClick={(e) => props.onClick({uuid: props.id, bucket: props.bucket}, e)} className="column is-one-third">
			<div style={imageCss} className="image is-16by9">
			</div>
			<p className="imageitem__title"><strong>{props.name}</strong></p>
			{props.size > 0 && <p className="imageitem__size">{props.size}</p>} 
		</div>		
	)
}

export default ImageItem;


// WEBPACK FOOTER //
// ./src/components/image-item.jsx